module.exports = __webpack_public_path__ + "templates.user-reminder-mobile-52b4e8e2.html";